import React, { FC } from 'react';
import { GameType, useGame } from '../../context/GameContext';
import { DartsScoreboard } from './DartsScoreboard';
import { ClassicScoreboard } from './ClassicScoreboard';

export const Scoreboard: FC = () => {
  const {
    gameSettings: { type },
  } = useGame();

  return type === GameType.DARTS ? <DartsScoreboard /> : <ClassicScoreboard />;
};
